import React, { useState, forwardRef, useEffect } from "react";
import { AiOutlineUpload } from "react-icons/ai";

const UploadWithoutModal = forwardRef((props, ref) => {
  const {
    value,
    isSubmitted,
    message,
    defValue,
    error,
    label,
    id,
    icon,
    type,
    setCreateObjectURL,
    setFileName,
    ...rest
  } = props;

  const handleChange = ({ target }) => {
    setFileName(target.files[0].name);
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      const image = reader.result;
      if (setCreateObjectURL) setCreateObjectURL(reader.result);
    });
    reader.readAsDataURL(target.files[0]);
  };

  useEffect(() => {
    if (isSubmitted) {
      setFileName("");
    }
  }, [isSubmitted]);

  return (
    <div className=" w-full  border-solid border border-[#21212199] rounded-[1.5rem] relative cursor-pointer">
      <div className=" flex flex-row items-center justify-between w-full px-[1.6rem] py-[0.6rem]">
        <label
          className=" text-[#21212199] text-[1.8rem] font-normal leading-[3.2rem] "
          style={{ display: "flex" }}
        >
          {label}
        </label>

        <label htmlFor={id} className="UploadContent__icon">
          {icon}
        </label>
      </div>

      <div className="w-full h-full">
        <input
          ref={ref}
          type="file"
          onInput={handleChange}
          className=" w-full  opacity-0 absolute top-0  h-full z-10 cursor-pointer"
          {...rest}
          id={id}
        />
      </div>

      {error && <span className="input__message">{message}</span>}
    </div>
  );
});

export default UploadWithoutModal;
